export function taxonomyDetailUrl(taxonomyId: number): string {
    return `taxonomy/${taxonomyId}/`;
}

/** Every taxonomy (GET); a databag can be linked to any of them. */
export function taxonomyListUrl(): string {
    return 'taxonomy/';
}

/** A databag (PATCH `{taxonomy}` links it to another taxonomy). */
export function databagUrl(databagId: number): string {
    return `bag/${databagId}/`;
}

/** Saves a new state of the whole tree; the same endpoint the current builder uses for every edit. */
export function taxonomyStoreStateUrl(taxonomyId: number): string {
    return `taxonomy/${taxonomyId}/store_state/`;
}

/** Taxonomy approval requests: POST `{taxonomy, notes}` sends a taxonomy for approval. */
export function taxonomyApprovalRequestsUrl(): string {
    return 'approve/taxonomy/';
}

/** One taxonomy approval request: GET reads it (notes, status, requester). */
export function taxonomyApprovalRequestUrl(approvalId: number): string {
    return `approve/taxonomy/${approvalId}/`;
}

/** The approver's own copy of the tree and its history (GET). */
export function taxonomyApprovalStateUrl(approvalId: number): string {
    return `approve/taxonomy/${approvalId}/state/`;
}

/** PUT a new state of the approver's copy (an edit, revert or note). */
export function taxonomyApprovalStateNextUrl(approvalId: number): string {
    return `approve/taxonomy/${approvalId}/state/next/`;
}

/** PUT `{history_number}`: undo / redo in the approver's copy. */
export function taxonomyApprovalStateHistoryUrl(approvalId: number): string {
    return `approve/taxonomy/${approvalId}/state/history/`;
}

/** Approve: the approver's copy becomes the new taxonomy; data is not touched. */
export function taxonomyApprovalApproveUrl(approvalId: number): string {
    return `approve/taxonomy/${approvalId}/apply_taxonomy_only/`;
}

/** Set the request's status, e.g. `rejected`. */
export function taxonomyApprovalApplyUrl(approvalId: number): string {
    return `approve/taxonomy/${approvalId}/apply/`;
}

/** The taxonomy's operations, oldest first: the undo / redo list. */
export function taxonomyHistoryUrl(taxonomyId: number): string {
    return `taxonomy/${taxonomyId}/history/`;
}

/** Undo / redo: makes another operation the active state; nothing is deleted. */
export function taxonomyGotoHistoryUrl(taxonomyId: number): string {
    return `taxonomy/${taxonomyId}/goto_history/`;
}
